import {
  createRouter,
  createWebHashHistory
} from 'vue-router'
import Home from '../views/Home.vue'
import LoginPage from '../views/LoginPage.vue'

var Lockr = require("lockr");
// this.myNum = Lockr.get("pajn39jad", 1); // get is password
// this.branchLableType = Lockr.get("branchLableType", 1);

var routes;
if (Lockr.get("pajn39jad", 1) == "121") {

  routes = [{
      path: '/',
      name: 'Home',
      component: Home
    },

    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
      path: '/setting',
      name: 'Setting',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ '../views/Setting.vue')
    },
    {
      path: '/feeder/:feederId',
      name: 'Feeder',
      component: () => import( /* webpackChunkName: "about" */ '../views/Feeder.vue')
    },
    {
      path: '/feeder-c/:feederId',
      name: 'FeederWithComponent',
      component: () => import('../views/FeederWithComponent.vue')
    },
    {
      path: '/feeder-list',
      name: 'FeederList',
      component: () => import( /* webpackChunkName: "about" */ '../views/FeederList.vue')
    },
    {
      path: '/print',
      name: 'PrintArea',
      component: () => import('../views/PrintArea.vue')
    },
    {
      path: '/simple-edit/:tableName/:whereName/:whereValue',
      name: 'SimpleEdit',
      component: () => import('../views/SimpleEdit.vue')
    },
    {
      path: '/simple-edit-D/:tableName/:whereName/:whereValue',
      name: 'SimpleEdit_copy_for_D',
      component: () => import('../views/SimpleEdit_copy_for_D.vue')
    },
    {
      path: '/feeder-pre-cal/:feederId',
      name: 'PreCAL',
      component: () => import('../views/PreCAL.vue')
    },
    {
      path: '/feeder-pre-cu-cal/:feederId',
      name: 'PreCuCal',
      component: () => import('../views/PreCuCal.vue')
    },
    {
      path: '/feeder-print/:feederId',
      name: 'FeederPrint',
      component: () => import('../views/FeederPrint.vue')
    },
    {
      path: '/feeder-print-a3/:feederId',
      name: 'FeederPrintA3',
      component: () => import('../views/FeederPrintA3.vue')
    },
    {
      path: '/feeder-print-ba3/:feederId',
      name: 'FeederPrintBigA3',
      component: () => import('../views/FeederPrintBigA3.vue')
    },
    {
      path: '/feeder-print-legend/:feederId',
      name: 'FeederPrintLegend',
      component: () => import('../views/FeederPrintLegend.vue')
    },
    {
      path: '/feeder-print-legend-a3/:feederId',
      name: 'FeederPrintLegendA3',
      component: () => import('../views/FeederPrintLegendA3.vue')
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    // {
    //   path: '/add-remove-feeder/:feederId/:tableName/:whereName/:whereValue',
    //   name: 'AddRemoveFeederFromEl',
    //    component: () => import('../views/AddRemoveFeederFromEl.vue')
    // },





    // {
    //   path: '/feeder/:feederId/print',
    //   name: 'PrintArea',
    //    component: () => import('../views/PrintArea.vue')
    // }
  ];
} else {

  routes = [{
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/:everything',
      name: 'LoginPage',
      component: LoginPage
    },
    // {
    //   path: '/:everything/:isok',
    //   name: 'LoginPage',
    //   component: LoginPage
    // },
    // {
    //   path: '/:everything/:he/:ho',
    //   name: 'LoginPage',
    //   component: LoginPage
    // },
  ];
}

console.log(routes);


const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router